import angular from 'angular';
import '../../shared.module';
import { requestData } from '../../helpers/http-error.helper';
import { seatMapPayload, toSeatMap, toSessionSeating } from './seat-map.helper';

class SeatMapApiService {
  constructor($http, $q, API_BASE_URL) {
    this.$http = $http;
    this.$q = $q;
    this.API_BASE_URL = API_BASE_URL;
  }

  resourceUrl(resourceId) {
    return `${this.API_BASE_URL}/commerce/resources/${resourceId}/seat-map`;
  }

  get(resourceId) {
    return requestData(
      this.$q,
      this.$http.get(this.resourceUrl(resourceId)),
      'Não foi possível carregar o mapa de assentos.',
      toSeatMap
    );
  }

  save(resourceId, map) {
    return requestData(
      this.$q,
      this.$http.put(this.resourceUrl(resourceId), seatMapPayload(map), { silentErrors: true }),
      'Não foi possível salvar o mapa de assentos.',
      toSeatMap
    );
  }

  sessionSeats(sessionId) {
    return requestData(
      this.$q,
      this.$http.get(`${this.API_BASE_URL}/commerce/sessions/${sessionId}/seats`, {
        silentErrors: true
      }),
      'Não foi possível carregar os assentos da sessão.',
      toSessionSeating
    );
  }
}

SeatMapApiService.$inject = ['$http', '$q', 'API_BASE_URL'];

angular.module('app.shared').service('SeatMapApiService', SeatMapApiService);

export default SeatMapApiService;
